import React from 'react';

interface EmbeddedBlob {
  originalUrl: string;
  blob: Blob;
  blobUrl?: string; // generated at runtime
}

const RichTextContent: React.FC<{
  content: string;
  embeddedBlobs?: EmbeddedBlob[];
}> = ({ content, embeddedBlobs }) => {
  const [resolvedContent, setResolvedContent] = React.useState(content);

  React.useEffect(() => {
    if (!embeddedBlobs || embeddedBlobs.length === 0) return;

    const blobUrlMap = new Map<string, string>();

    embeddedBlobs.forEach(({ originalUrl, blob }) => {
      const url = URL.createObjectURL(blob);
      blobUrlMap.set(originalUrl, url);
    });

    let updated = content;
    blobUrlMap.forEach((blobUrl, originalUrl) => {
      const safe = originalUrl.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      updated = updated.replace(new RegExp(safe, 'g'), blobUrl);
    });

    setResolvedContent(updated);

    return () => blobUrlMap.forEach((url) => URL.revokeObjectURL(url));
  }, [content, embeddedBlobs]);

  React.useEffect(() => {
    const container = document.querySelector('.content__body') as HTMLElement;
    if (!container) return;

    const videos = container.querySelectorAll('video');
    if (!videos.length) return;

    const updateVideoSize = () => {
      videos.forEach((video) => {
        video.style.maxHeight = `${container.clientHeight - 100}px`;
        video.style.maxWidth = '100%';
        video.style.objectFit = 'contain';
        video.style.height = 'auto';
      });
    };

    updateVideoSize();
    window.addEventListener('resize', updateVideoSize);
    return () => window.removeEventListener('resize', updateVideoSize);
  }, [resolvedContent]);

  return (
    <div
      className={'richtext-content'}
      style={{
        width: '100%'
      }}
      dangerouslySetInnerHTML={{
        __html: resolvedContent
      }}
    />
  );
};

// wrap it using memo to prevent rerender that makes video reset again and again
export default React.memo(RichTextContent);
